import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

import hasSubscriptionAccess from "utils/hasSubscriptionAccess"
import { StatsReportChartsWrapper } from "modals/StatsReportModal/StatsReportChartsWrapper"
import { SubscriptionUpgradeModal } from "modals/SubscriptionUpgradeModal/SubscriptionUpgradeModal"

import { useCustomerDashboard } from "../CustomerDashboardContext"

const MonitoringContainer = styled.div<{ sidebarOpen?: boolean }>`
  margin-top: 2px;
  padding: 23px ${({ sidebarOpen }) => (sidebarOpen ? "24px" : "0")} 20px 0;
  max-height: calc(100dvh - 255px);
  overflow-y: auto;
`

export const CustomerDashboardMonitoring = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const { devices, currentDevice, isSidebarOpen } = useCustomerDashboard()
  const userTemperatureScale = useAppSelector(state => state.user.userTemperatureScale)
  const isCelsius = userTemperatureScale === "celsius"
  const hasMonitoringAccess = userProfile ? hasSubscriptionAccess(userProfile, SubscriptionPrivilege.Monitoring) : false

  const selectedDevice = devices[currentDevice]

  if (!selectedDevice) {
    return null
  }

  return (
    <>
      <MonitoringContainer sidebarOpen={isSidebarOpen}>
        <StatsReportChartsWrapper device={selectedDevice} isCelsius={isCelsius} useTabsComponent={true} />
      </MonitoringContainer>
      {!hasMonitoringAccess && <SubscriptionUpgradeModal page={SubscriptionPrivilege.Monitoring} />}
    </>
  )
}
